import DiscountsList from './DiscountsList';

export default DiscountsList;
